import { ScriptedAnimationFactory, ScriptedAnimation } from "slotworks/graphics/animation/scripted-animation";
import Rectangle from "slotworks/utils/geom/rectangle";
import IntroAnimation from "./intro-animation";

export default class IntroAnimationFactory implements ScriptedAnimationFactory {
    public create(position: Rectangle): ScriptedAnimation {
        const animation = new IntroAnimation(position);
        return animation;
    }
}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/animations/intro-animation-factory.ts